/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });


/*************************************************/
/* Partials                                      */
/*************************************************/

import { intersectionObservation } from "./partials/intersectionObservation.js";
import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { menu } from "./partials/menu.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { accordion } from "./partials/accordion.js";
import { factsBlocks } from "./partials/factsBlocks.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { ctaButton } from "./partials/ctaButton.js";
import { logoSlider } from "./partials/logoSlider.js";
import { articlesSlider } from "./partials/articlesSlider.js";
import { selectedProductsSlider } from "./partials/selectedProductsSlider.js";
import { cardsSlider } from "./partials/cardsSlider.js";
import { gallerySlider } from "./partials/gallerySlider.js";
import { locationsOverview } from "./partials/locationsOverview.js";
import { categoryOverview } from "./partials/categoryOverview.js";
import { productGallery } from "./partials/productGallery.js";
import { productNav } from "./partials/productNav.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    if(formSubmittedElement){
        window.scrollTo(0,formSubmittedElement.closest('.form-item').offsetTop);
    }

    //Fire dataLayer event for forms submission
    const formSubmitMessage = document.querySelector('[class^="umbraco-forms-submitmessage"]');
    if(formSubmitMessage){
        window.dataLayer.push({
            'event': 'formSubmission',
            'formType':formSubmitMessage.dataset.formName
        });
    }

    //Add click listener to skip link
    document.querySelector('#skipLink').addEventListener('click',e => {
        document.querySelector('#mainContent').focus();
    });
    
    intersectionObservation();
    header(body);
    language();
    menu();
    search();
    searchbar(body);
    accordion();
    factsBlocks();
    modal(body, bodyLoadingClass);
    video();
    cookies();
    ctaButton();
    logoSlider();
    articlesSlider();
    selectedProductsSlider();
    cardsSlider();
    gallerySlider();
    locationsOverview();
    categoryOverview();
    productGallery();
    productNav();
});
